import ReturnsIndexPage from "./ReturnsIndexPage";
export default ReturnsIndexPage;
